import { newE2EPage } from "@stencil/core/testing";
import { testValidHtml } from "../../../test-utils/html-validate";

describe("textarea-field", () => {
    it("should render a component", async () => {
        const page = await newE2EPage();
        await page.setContent(`<ux-textarea-field></ux-textarea-field>`);
        const el = await page.find("ux-textarea-field");
        expect(el).toHaveClass("hydrated");
    });

    it("should emit the right events", async () => {
        const page = await newE2EPage();
        await page.setContent(`<ux-textarea-field name="textarea-1" textarea-id="1"></ux-textarea-field>`);
        await page.waitForChanges();
        const textarea = await page.find("ux-textarea-field textarea");
        const textareaFieldChangeEvent = await page.spyOnEvent("uxTextareaFieldChange");
        const uxInputEvent = await page.spyOnEvent("uxInput");
        await textarea.press("A");
        expect(textareaFieldChangeEvent).toHaveReceivedEventDetail({
            name: "textarea-1",
            value: "A",
            textareaFieldId: "1"
        });
        expect(uxInputEvent).toHaveReceivedEvent();
    });

    it("should match to snapshot", async () => {
        const page = await newE2EPage();
        await page.setContent(`<ux-textarea-field></ux-textarea-field>`);
        const el = await page.find("ux-textarea-field");
        expect(el).toMatchSnapshot();
    });

    it("should render valid html", async () => {
        await testValidHtml(`<ux-textarea-field></ux-textarea-field>`);
    });
});
